import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function StickyTopBar() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return;
}